import { useQuery } from "@tanstack/react-query";
import { ClientKeys } from "web_myplann/Api/Client/ClientKeys";
import {
	type GetClientV2FetchResponse,
	getClientV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseBase } from "web_myplann/Infrastructure/Api/ApiUtils";

const clientQueryFn = processResponseBase(() => getClientV2());

function useClientQueryBase<TSelect = GetClientV2FetchResponse>(options?: {
	select?: (data: GetClientV2FetchResponse) => TSelect;
}) {
	return useQuery<GetClientV2FetchResponse, Error, TSelect>({
		queryKey: ClientKeys.all,
		queryFn: clientQueryFn,
		...options,
	});
}

export const useClientQuery = () =>
	useClientQueryBase({
		select: (data) => (data.status === 200 ? data.data : undefined),
	});

export const useIsNoAdvisorQuery = () =>
	useClientQueryBase({
		select: (data) => (data.status as number) === 404,
	});
